
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { IApplicationState } from "@/store/applications/types";
import api from "@/api/signup/api";
import { parseStreetAddress } from "@/helpers/address";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);

export default Vue.extend({
  computed: {
    physicalAddressDetails() {
      return store.state.application.physicalAddressLookup;
    },
    deliveryAddressDetails() {
      return store.state.application.deliveryAddressLookup;
    },
    offerOrPromo(): string {
      const offer =
        store.state.standardOffer && store.state.standardOffer.offer.name;

      const promo =
        store.state.application.applicationData &&
        store.state.application.applicationData.loyaltyDetails &&
        store.state.application.applicationData.loyaltyDetails.promoCode;

      return promo || offer || "";
    },
    physicalStreet(): string {
      return (
        parseStreetAddress(this.physicalAddressDetails) ||
        (this as any).physicalAddressText
      );
    },
    physicalTownCity(): string {
      return (
        (this.physicalAddressDetails && this.physicalAddressDetails.cityTown) ||
        (this.physicalAddressDetails && this.physicalAddressDetails.mailTown) ||
        ""
      );
    },
    physicalPostCode(): string {
      return (
        (this.physicalAddressDetails && this.physicalAddressDetails.postcode) ||
        ""
      );
    },
    deliveryStreet(): string {
      return (
        parseStreetAddress(this.deliveryAddressDetails, true) ||
        (this as any).deliveryAddressText
      );
    },
    deliveryTownCity(): string {
      return (
        (this.deliveryAddressDetails && this.deliveryAddressDetails.cityTown) ||
        (this.deliveryAddressDetails && this.deliveryAddressDetails.mailTown) ||
        ""
      );
    },
    deliveryPostCode(): string {
      return (
        (this.deliveryAddressDetails && this.deliveryAddressDetails.postcode) ||
        ""
      );
    },
    ...mapState({
      applicantFullName: (state: IApplicationState) =>
        state.applicationData && state.applicationData.fullName,
      invoiceEmail: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.finalDetails &&
        state.applicationData.finalDetails.invoiceEmail,
      contactNumber: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.finalDetails &&
        state.applicationData.finalDetails.contactNumber,
      physicalAddress: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.businessDetails &&
        store.state.application.applicationData.businessDetails.physicalAddress,
      physicalAddressText: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.businessDetails &&
        store.state.application.applicationData.businessDetails
          .physicalAddressText,
      deliveryAddress: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.finalDetails &&
        store.state.application.applicationData.finalDetails.deliveryAddress,
      deliveryAddressText: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.finalDetails &&
        store.state.application.applicationData.finalDetails.deliveryAddressText
    })
  },
  validations: {}
});
